module.exports = __webpack_public_path__ + "media/images/fair_star-7d54f5ff1e9bb0bf38239b932f6ea892.svg";